import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { Text, View, StyleSheet } from 'react-native';
import { getNextBookingStep } from '../actions';
import { getMomentFormat } from '../../utils';
import { styles as sharedStyles } from './Styles';
import { ProcessTypes } from 'fitbeat.gym-core';
import { Button, ButtonTypes, Icon } from '../../components';
import Theme from '../../theme';
import { getGymTimezone } from '../../utils/gyms';
import { toggleBookingsModal } from '../../ui';

class BookingChanged extends Component {
  static getTitle = () => '';
  static getSubtitle = () => null;

  done = () => {
    const { userProfile, getNextBookingStep, toggleBookingsModal } = this.props;
    getNextBookingStep(userProfile, ProcessTypes.Cancel);
    toggleBookingsModal(false);
  }

  render() {
    const { t, workoutSession } = this.props;
    return (
      <View style={sharedStyles.container}>
        <View style={styles.container}>
          <Icon
            size={80}
            name="ios-checkmark-circle-outline"
            color={Theme.GREEN}
          />
          <Text style={styles.title}>{t('bookingChanged')}</Text>
          <Text style={styles.date}>
            {getMomentFormat(workoutSession.startTimeOfFirstExercise, 'HH:mm dddd, Do MMMM', getGymTimezone(workoutSession))}
          </Text>
        </View>
        <View style={styles.footer}>
          <Button
            title={t('done')}
            fontColor={Theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
            onPress={this.done}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center'
  },
  title: {
    fontSize: 35,
    color: Theme.CHARCOAL,
    fontFamily: Theme.CustomBold,
  },
  date: {
    fontSize: 18,
    color: Theme.GREY_DARK,
    fontFamily: Theme.Custom300,
  },
  footer: {
    paddingVertical: 10
  }
});

const mapStateToProps = (state) => {
  return {
    workoutSession: state.bookings.bookingWizard.workoutSession,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getNextBookingStep: (userProfile, processType) => dispatch(getNextBookingStep(userProfile, processType)),
    toggleBookingsModal: (isVisible) => dispatch(toggleBookingsModal(isVisible)),
  };
};

BookingChanged = connect(mapStateToProps, mapDispatchToProps)(BookingChanged);
export default translate(['bookings'], { wait: true })(BookingChanged);
